module.exports = __webpack_public_path__ + "img/NChief64_ua.8ec8d053.webp";